// extracted by mini-css-extract-plugin
export var container = "_9a-0";
export var fallback = "_9a-5";
export var fallbackIcon = "_9a-6";
export var hidden = "_9a-2";
export var image = "_9a-3";
export var loaded = "_9a-4";
export var placeholder = "_9a-1";